// extracted by mini-css-extract-plugin
export default {"textinput":"TextInput_textinput__JOvOS"};